module.exports = __webpack_public_path__ + "SM.png?895a723d083a7090c1068c908686d153";